module.exports = require("process");


//////////////////
// WEBPACK FOOTER
// external "process"
// module id = 160
// module chunks = 2